import { EventEmitter, Injectable } from '@angular/core';
import { RightPanelService } from '@shared/interactions';
import { RightPanelActionParams } from './services-list/service-list.interface';
import { AbstractControl } from '@angular/forms';
import { map, of } from 'rxjs';
import { Router } from '@angular/router';
import { DialogService } from '@shared/interactions/dialog/dialog.service';

@Injectable({
    providedIn: 'root'
})
export class ServiceInteractionsService {
    constructor(
        private readonly router: Router,
        private readonly rightPanelService: RightPanelService,
        private readonly dialogService: DialogService
    ) {}

    public rightPanelClick(params: RightPanelActionParams): void {
        const onCreated = new EventEmitter();
        const onSaveDraft = new EventEmitter<number>();
        let isDraftSaved = false;

        const dialog = this.rightPanelService.open({
            class: params.class ?? '',
            title: params.title,
            entryContext: params.entryContext ?? null,
            managed: false,
            outputs: { onCreated, onSaveDraft },
            module: params.module,
            beforeClose: (component: { form: AbstractControl; }) => {
                if (component.form.pristine) {
                    return of(component.form.pristine);
                }

                if (isDraftSaved) {
                    return of(true);
                }

                return this.dialogService.openConfirmDialog({
                    width: params?.confirmDialogSettings?.width || 400,
                    title: params?.confirmDialogSettings?.title || 'Potwierdzenie',
                    message: params?.confirmDialogSettings?.message || 'Czy na pewno chcesz zamknąć formularz?',
                    buttonAccept: params?.confirmDialogSettings?.buttonAccept || 'Tak',
                    buttonCancel: params?.confirmDialogSettings?.buttonCancel || 'Nie'
                }).afterClosed().pipe(map(x => Boolean(x)));
            }
        });

        onCreated.subscribe(() => {
            if (params.redirectOnSuccess) {
                this.router.navigate([params.redirectOnSuccess]);
            }

            dialog.close();
            onCreated.unsubscribe();
        });

        onSaveDraft.subscribe(() => {
            isDraftSaved = true;

            if (params.redirectOnSaveDraft) {
                this.router.navigate([params.redirectOnSaveDraft]);
            }

            // Opt-in: some panels must be closed explicitly because closeOnNavigation does not fire for them.
            if (params.closeOnSaveDraft) {
                dialog.close();
                onSaveDraft.unsubscribe();
            }
        });
    }
}
